module.exports = __webpack_public_path__ + "static/media/do.ef9fbd49.svg";